const dashboard = {
  Title: 'Career Dashboard',
  CreateNewJob: 'Create New Job',
  JobListings: {
    Title: 'Job Listings',
    EmptyMessage: 'Your job listings will appear here.',
    Filter: {
      Status: 'Status',
    },
  },
};

export default dashboard;
